import { useTranslation } from "react-i18next";

import { formatPercent } from "@/shared/lib";

import type { RiskLevel } from "../model/types";

/**
 * Figma: `RiskMeter/Medium` (18:61) — 350×150, шкала 322×12.
 *
 * В макете нарисован только средний уровень. Три состояния строятся по тому же
 * образцу: заполнение и цвет берутся из `risk_level`, значение просадки — из
 * `declared_max_dd`, то есть с бэкенда, а не из шкалы.
 *
 * Движение (FE-13): шкала заполняется от нуля при появлении — уровень риска
 * читается как величина, а не как готовая полоска.
 */
const LEVELS: Record<RiskLevel, { fill: string; tone: string; width: string }> = {
  low: { fill: "bg-status-profit", tone: "text-status-profit", width: "33%" },
  medium: { fill: "bg-status-warning", tone: "text-status-warning", width: "66%" },
  high: { fill: "bg-status-loss", tone: "text-status-loss", width: "100%" },
};

export function RiskMeter({ level, maxDd }: { level: RiskLevel; maxDd: string }) {
  const { t } = useTranslation();
  const style = LEVELS[level];

  return (
    <section className="flex w-full flex-col gap-3 rounded-[22px] border border-border-subtle bg-background-elevated p-[18px]">
      <header className="flex items-start justify-between text-label">
        <span className="font-medium text-text-secondary">{t("buy.riskLimit")}</span>
        <span className={`font-semibold ${style.tone}`}>
          {t(`robots.risk.${level}`)} · {formatPercent(maxDd)} DD
        </span>
      </header>

      <div
        className="h-3 w-full overflow-hidden rounded-full bg-background-raised"
        role="meter"
        aria-label={t("buy.riskLimit")}
      >
        <div
          className={`animate-meter-fill h-full rounded-full ${style.fill}`}
          style={{ width: style.width }}
        />
      </div>

      <p className="text-caption font-normal text-text-secondary">{t("buy.riskNote")}</p>
    </section>
  );
}
